module.exports = __webpack_public_path__ + "img/beneficio-1.1e1fd7ef.svg";